import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import { CreditSafeReportRelatedCompany, CreditSafeReportRelatedCompanySchema } from '../credit-safe.report.related-company';
import { CreditSafeReportRelatedPerson, CreditSafeReportRelatedPersonSchema } from './credit-safe.report.related-person';
import { CreditSafeReportCompliance, CreditSafeReportComplianceSchema } from './credit-safe.report.compliance';
import { CreditSafeReportFinancialStatement, CreditSafeReportFinancialStatementSchema } from './credit-safe-report.financial-statement';
import { CreditSafeInternationalScoreEnum, CreditSafeInternationalScoreSchema } from './credit-safe.internationalScore';

export const CreditSafeCreditLimitReportSchema = z
    .object({
        amount: z.number(),
        currency: EnumSchema(Currency),
    })
    .strict();

export const CreditSafeReportDataSchema = z
    .object({
        creditLimit: CreditSafeCreditLimitReportSchema.optional(),
        riskScore: z.number().optional(),
        internationalScore: EnumSchema(CreditSafeInternationalScoreEnum).optional(),
        complianceAlerts: z.number().optional(),
        dbt: z.number().optional(),
        paymentExperiences: z.number().optional(),
        paymentTrend: z.string().optional(),
        inquiriesTrend: z.string().optional(),
        relatedCompanies: z.array(CreditSafeReportRelatedCompanySchema).optional(),
        relatedPersons: z.array(CreditSafeReportRelatedPersonSchema).optional(),
        compliance: CreditSafeReportComplianceSchema.optional(),
        totalPaid: z.number().optional(),
        totalPaidOnTime: z.number().optional(),
        financialStatement: CreditSafeReportFinancialStatementSchema.optional(),
        businessStartDate: z.date().optional(),
        website: z.string().optional(),
        phone: z.string().optional(),
    })
    .strict();

export class CreditSafeCreditLimitReport extends FromSchema(CreditSafeCreditLimitReportSchema) {
    amount: number;
    currency: Currency;
}

export class CreditSafeReportData extends FromSchema(CreditSafeReportDataSchema) {
    creditLimit?: CreditSafeCreditLimitReport;
    riskScore?: number;
    internationalScore?: CreditSafeInternationalScoreEnum;
    complianceAlerts?: number;
    dbt?: number;
    paymentExperiences?: number;
    paymentTrend: string;
    inquiriesTrend: string;
    totalPaid?: number;
    totalPaidOnTime?: number;
    relatedCompanies?: CreditSafeReportRelatedCompany[];
    relatedPersons?: CreditSafeReportRelatedPerson[];
    compliance?: CreditSafeReportCompliance;
    financialStatement?: CreditSafeReportFinancialStatement;
    businessStartDate?: Date;
    website?: string;
    phone?: string;
}
